// print  sub title text for FullArticleView
const SubTitleText = ({ text }) => {
  return <h5>{text}</h5>;
};

export default SubTitleText;
